import { switchMap } from 'rxjs/operators';
import { ITileData } from '../net-dash-tile-data/net-dash-tile-data.service';
import { Component, ElementRef, EventEmitter, Inject, Input, Output, ViewChild, SimpleChange } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UtilitiesService } from 'Src/ng2/shared/services/utilities/utilities.service';
import { Observable, Observer } from 'rxjs';
import { sortedUniqBy } from 'lodash';

@Component({
  selector: 'tiles',
  template: require('./tiles.component.html'),
  styles: [require('./tiles.scss')],
})
export class TilesComponent {
  @Input() tiles: Array<ITileData>;
  @Input() filterFormControl: FormControl;

  @Output() clearSearch = new EventEmitter();
  @Output() setPanelShadowStyle = new EventEmitter<boolean>();
  @Output() tileClickEmitter = new EventEmitter<ITileData>();

  public tileData$: Observable<Array<ITileData>>;

  @ViewChild('tilesContainer', { static: false }) tilesContainer: ElementRef;

  constructor(private utilitiesService: UtilitiesService) {}

  ngOnInit(): void {
    this.tileData$ = this.getTileData$(this.tiles);
  }

  ngOnChanges(_change: SimpleChange) {
    this.tileData$ = this.getTileData$(this.tiles);
  }

  // UI SPECIFICS
  public onWindowScroll(): void {
    const scrolled: boolean = this.utilitiesService.showListPanelShadow(this.tilesContainer.nativeElement.scrollTop);
    this.setPanelShadowStyle.emit(scrolled);
  }

  public onClear(): void {
    this.clearSearch.emit();
  }

  public emitTileClick(tile): void {
    this.tileClickEmitter.emit(tile);
  }

  private getTileData$(tiles: Array<ITileData>) {
    return Observable.create(
      (observer: Observer<{ tilesByCategory: { [category: string]: ITileData }; tileCategories: Array<string> }>) => {
        const tilesByCategory = this.organizeTilesByCategory(tiles);
        const tileCategories = this.getTileCategories(tiles);
        const tileData = { tilesByCategory, tileCategories };
        observer.next(tileData), observer.complete();
      },
    );
  }

  private organizeTilesByCategory(tiles: Array<ITileData>): { [category: string]: ITileData } {
    return tiles.reduce((tilesByCategory, tile) => {
      const { category } = tile;
      if (!tilesByCategory[category]) tilesByCategory[category] = [];
      tilesByCategory[category].push(tile);
      return tilesByCategory;
    }, {});
  }

  private getTileCategories(tiles: Array<ITileData>): Array<string> {
    return sortedUniqBy(tiles, tile => tile.category_order).map(({ category }) => category);
  }
}
